import React, { FC } from 'react';
import { FilterSelectContainer } from './SearchableFilterBar.styles';
import {
  AllieSearchableSelect,
  AllieSelectOptionProps,
  AllieText,
  handleOnSelect,
} from '../../../components';

interface FilterConfig {
  options: AllieSelectOptionProps[];
  selectedValue: string | undefined;
  handleOnSelect: (value: string | number) => void;
  label: string;
  placeholder?: string;
}

export const SearchableFilterBar: FC<{ filters: FilterConfig[] }> = ({ filters }) => {
  return (
    <>
      {filters.map((filter) => (
        <FilterSelectContainer key={filter.label}>
          <AllieText type="body3" weight={400} color="neutral-50">
            {filter.label}
          </AllieText>
          <AllieSearchableSelect
            options={filter.options}
            selectedValue={filter.selectedValue}
            handleOnSelect={filter.handleOnSelect as handleOnSelect}
            placeholder={filter.placeholder}
          />
        </FilterSelectContainer>
      ))}
    </>
  );
};
